import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

const Topper = withStyles(styles)(props => {
  const { topper, classes } = props
  let theme;
  if (topper.type) theme = topper.type.replace(/\s/g, '_')
  return (
    <div className={classes.contents}>
      <div className={classes.topper}>
        <Grid container spacing={40}>
          <Grid item xs={12}>
            <Typography variant={'subheading'}>
              {topper.subtitle.text}
            </Typography>
            <Typography variant={'display1'} className={classes[`topper_${theme}`]}>{topper.title.text}</Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  )
})

export default withStyles(styles)(Topper)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/topper.js